import type {
  ApiSmarticoProfileEventParams,
  ApiSmarticoProfileEventPort,
} from '~/handlers/ports/api-smartico-profile-event.port';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';

export class ApostatudoApiSmarticoProfileEventAdapter
  implements ApiSmarticoProfileEventPort
{
  // Sem keepalive: o login nao e um cenario de unload, e precisamos do status
  // real da resposta (204 sucesso / 502 falha) para decidir se logamos o erro.
  async handle(params: ApiSmarticoProfileEventParams): Promise<void> {
    const response = await fetch(
      `${getApostatudoApiUrl()}/smartico/profile-event`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_ext_id: params.user_ext_id,
          event: params.event,
          payload: params.payload,
        }),
      },
    );

    if (!response.ok) {
      throw new Error(
        `[ApostatudoApiSmarticoProfileEventAdapter] APOSTATUDO API returned ${response.status}: ${response.statusText}`,
      );
    }
  }
}
